
import { Component, Prop, Vue } from 'nuxt-property-decorator'
import { isAfter } from 'date-fns'
import AppTimer from '@/components/widgets/AppTimer.vue'
import { convertToLocalDateTime } from '~/utils/dates.utils'
import ResponsiveImage from '~/components/ResponsiveImage/ResponsiveImage.vue'

const BLACK_FRIDAY_DATE = '2024-11-23T23:59:59.123Z'

@Component({
  components: {
    ResponsiveImage,
    AppTimer,
  },
})
export default class BlackFridayHeader extends Vue {
  @Prop({ type: String })
  readonly title!: string

  @Prop({ type: String })
  readonly subTitle!: string

  @Prop({ required: false, type: Boolean, default: false })
  readonly withTimer!: boolean

  get showTimer () {
    const localDate = convertToLocalDateTime(this.endTime)
    return !isAfter(new Date(), new Date(localDate))
  }

  get endTime () {
    return BLACK_FRIDAY_DATE
  }
}
